import PlayerTableRow from '@/utils/classes/PlayerTableRow';
import { getDataTablesCategories } from '@/utils/misc';

// Data structure for the possession table data rows
export const possessionPlayerTableRowItems = [
  {
    category: 'PASES  ACERTADOS',
    categoryIds: null,
    translationKey: 'table.possession.player.successful_passes',
    items: [
      {
        category: 'P. ACERTADOS 1/4',
        categoryIds: [213],
        translationKey: 'table.possession.player.successful_passes_1/4',
      },
      {
        category: 'P. ACERTADOS 2/4',
        categoryIds: [214],
        translationKey: 'table.possession.player.successful_passes_2/4',
      },
      {
        category: 'P. ACERTADOS 3/4',
        categoryIds: [215],
        translationKey: 'table.possession.player.successful_passes_3/4',
      },
      {
        category: 'P. ACERTADOS 4/4',
        categoryIds: [216],
        translationKey: 'table.possession.player.successful_passes_4/4',
      },
    ],
  },
  {
    category: 'PASES FILTRADOS',
    categoryIds: [217],
    translationKey: 'table.possession.player.through_passes',
  },
  {
    category: 'PASES NO ACERTADOS',
    categoryIds: null,
    translationKey: 'table.possession.player.unsuccessful_passes',
    items: [
      {
        category: 'P. NO ACERTADOS 1/4',
        categoryIds: [218],
        translationKey: 'table.possession.player.unsuccessful_passes_1/4',
      },
      {
        category: 'P. NO ACERTADOS 2/4',
        categoryIds: [219],
        translationKey: 'table.possession.player.unsuccessful_passes_2/4',
      },
      {
        category: 'P. NO ACERTADOS 3/4',
        categoryIds: [220],
        translationKey: 'table.possession.player.unsuccessful_passes_3/4',
      },
      {
        category: 'P. NO ACERTADOS 4/4',
        categoryIds: [221],
        translationKey: 'table.possession.player.unsuccessful_passes_4/4',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS EN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.player.ball_recovered_in_challenge',
    items: [
      {
        category: 'B.R.E.D CANCHA PROPIA',
        categoryIds: [485, 486],
        translationKey: 'table.possession.player.b_r_i_c_own_half',
      },
      {
        category: 'B.R.E.D CANCHA RIVAL',
        categoryIds: [487, 488],
        translationKey: 'table.possession.player.b_r_i_c_opponents_half',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS SIN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.player.ball_recovered_without_challenge',
    items: [
      {
        category: 'B.R.S.D CANCHA PROPIA',
        categoryIds: [489, 490],
        translationKey: 'table.possession.player.b_r_w_c_own_half',
      },
      {
        category: 'B.R.S.D CANCHA RIVAL',
        categoryIds: [491, 492],
        translationKey: 'table.possession.player.b_r_w_c_opponents_half',
      },
    ],
  },
  {
    category: 'BALONES PERDIDOS EN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.player.balls_lost_in_challenge',
    items: [
      {
        category: 'B.P.E.D. CANCHA PROPIA',
        categoryIds: [496, 497],
        translationKey: 'table.possession.player.b_l_i_c_own_half',
      },
      {
        category: 'B.P.E.D. CANCHA RIVAL',
        categoryIds: [498, 499],
        translationKey: 'table.possession.player.b_l_i_c_opponents_half',
      },
    ],
  },
  {
    category: 'BALONES PERDIDOS SIN DISPUTA',
    categoryIds: null,
    translationKey: 'table.possession.player.balls_lost_without_challenge',
    items: [
      {
        category: 'B.P.S.D. CANCHA PROPIA',
        categoryIds: [500, 501],
        translationKey: 'table.possession.player.b_l_w_c_own_half',
      },
      {
        category: 'B.P.S.D. CANCHA RIVAL',
        categoryIds: [502, 503],
        translationKey: 'table.possession.player.b_l_w_c_opponents_half',
      },
    ],
  },
];

// Data structure for the offensive table data rows
export const offensivePlayerTableRowItems = [
  {
    category: 'GOLES',
    categoryIds: null,
    translationKey: 'table.offensive.player.goals',
    items: [
      {
        category: 'GOLES PIE DENTRO DEL ÁREA',
        categoryIds: [57],
        translationKey: 'table.offensive.player.goals_foot_inside_penalty',
      },
      {
        category: 'GOLES PIE FUERA DEL ÁREA',
        categoryIds: [326],
        translationKey: 'table.offensive.player.goals_foot_outside_penalty',
      },
      {
        category: 'GOLES CABEZA',
        categoryIds: [56],
        translationKey: 'table.offensive.player.header_goals',
      },
      {
        category: 'GOLES TIRO LIBRE',
        categoryIds: [60],
        translationKey: 'table.offensive.player.free_kick_goals',
      },
      {
        category: 'GOLES PENAL',
        categoryIds: [59],
        translationKey: 'table.offensive.player.penalty_goals',
      },
    ],
  },
  {
    category: 'TIROS A GOL (ORIGEN)',
    categoryIds: null,
    translationKey: 'table.offensive.player.shots_on_goal_from',
    items: [
      {
        category: 'DENTRO DEL ÁREA',
        categoryIds: [514, 516],
        translationKey: 'table.offensive.player.inside_the_box',
        generalName: 'Tiros a gol dentro del área',
      },
      {
        category: 'FUERA DEL ÁREA',
        categoryIds: [513, 515],
        translationKey: 'table.offensive.player.outside_the_box',
        generalName: 'Tiros a gol fuera del área',
      },
    ],
  },
  {
    category: 'TIROS A GOL (DESTINO)',
    categoryIds: null,
    translationKey: 'table.offensive.player.shots_on_goal_to',
    items: [
      {
        category: 'CON DESTINO A PORTERÍA',
        categoryIds: [537, 540, 544, 547],
        translationKey: 'table.offensive.player.shots_on_goal',
        generalName: 'Tiros a gol con destino a portería',
      },
      {
        category: 'SIN DESTINO A PORTERÍA',
        categoryIds: [538, 541, 545, 548],
        translationKey: 'table.offensive.player.not_to_destiny',
        generalName: 'Tiros a gol sin destino a portería',
      },
      {
        category: 'BLOQUEADOS',
        categoryIds: [539, 542, 546, 549],
        translationKey: 'table.offensive.player.blocked',
        generalName: 'Tiros a gol bloqueados',
      },
    ],
  },
  {
    category: 'CENTROS POR IZQUIERDA',
    categoryIds: null,
    translationKey: 'table.offensive.player.centers_from_left',
    items: [
      {
        category: 'C.P.I. ACERTADOS',
        categoryIds: [98, 101, 104, 105],
        translationKey: 'table.offensive.player.successful_c_f_l_s',
      },
      {
        category: 'C.P.I. NO ACERTADOS',
        categoryIds: [106, 107, 108],
        translationKey: 'table.offensive.player.unsuccessful_c_f_l_s',
      },
    ],
  },
  {
    category: 'CENTROS POR DERECHA',
    categoryIds: null,
    translationKey: 'table.offensive.player.centers_from_right',
    items: [
      {
        category: 'C.P.D. ACERTADOS',
        categoryIds: [109, 112, 115, 116],
        translationKey: 'table.offensive.player.successful_c_f_r_s',
      },
      {
        category: 'C.P.D. NO ACERTADOS',
        categoryIds: [117, 118, 119],
        translationKey: 'table.offensive.player.unsuccessful_c_f_r_s',
      },
    ],
  },
  {
    category: 'BALONES GANADOS EN ÁREA RIVAL',
    categoryIds: [11],
    translationKey: 'table.offensive.player.balls_won_opponents_penalty',
  },
];

// Data structure for the defensive table data rows
export const defensivePlayerTableRowItems = [
  {
    category: 'BALONES RECUPERADOS CANCHA RIVAL',
    categoryIds: null,
    translationKey: 'table.defensive.player.balls_recovered_opponents_half',
    items: [
      {
        category: 'B.R.C.R. EN DISPUTA',
        categoryIds: [487, 488],
        translationKey: 'table.defensive.player.b_r_o_h_in_challenge',
      },
      {
        category: 'B.R.C.R. SIN DISPUTA',
        categoryIds: [491, 492],
        translationKey: 'table.defensive.player.b_r_o_h_without_challenge',
      },
    ],
  },
  {
    category: 'BALONES RECUPERADOS CANCHA PROPIA',
    categoryIds: null,
    translationKey: 'table.defensive.player.balls_recovered_own_half',
    items: [
      {
        category: 'B.R.C.P. EN DISPUTA',
        categoryIds: [485, 486],
        translationKey: 'table.defensive.player.b_r_own_h_in_challenge',
      },
      {
        category: 'B.R.C.P. SIN DISPUTA',
        categoryIds: [489, 490],
        translationKey: 'table.defensive.player.b_r_own_h_without_challenge',
      },
    ],
  },
  {
    category: 'BALONES GANADOS EN ÁREA PROPIA',
    categoryIds: [23],
    items: null,
    translationKey: 'table.defensive.player.balls_won_own_penalty_box',
  },
  {
    category: '1 VS 1 EXITOSOS',
    categoryIds: null,
    translationKey: 'table.defensive.player.successful_1_on_1',
    items: [
      {
        category: 'OFENSIVOS',
        categoryIds: [4],
        translationKey: 'table.defensive.player.attacking',
        generalName: '1 vs 1 exitoso Ofensivo',
      },
      {
        category: 'DEFENSIVOS',
        categoryIds: [5],
        translationKey: 'table.defensive.player.defensive',
        generalName: '1 vs 1 exitoso Defensivo',
      },
    ],
  },
  {
    category: 'BARRIDAS',
    categoryIds: null,
    translationKey: 'table.defensive.player.slide_tackles',
    items: [
      {
        category: 'CON POSESIÓN',
        categoryIds: [521],
        translationKey: 'table.defensive.player.with_possession',
        generalName: 'Barridas con posesión',
      },
      {
        category: 'SIN POSESIÓN',
        categoryIds: [522],
        translationKey: 'table.defensive.player.without_possession',
        generalName: 'Barridas sin posesión',
      },
      {
        category: 'PROVOCA FALTA',
        categoryIds: [543],
        translationKey: 'table.defensive.player.with_foul_committed',
        generalName: 'Barridas que provocan falta',
      },
    ],
  },
  {
    category: 'CENTROS PERMITIDOS',
    categoryIds: [517],
    items: null,
    translationKey: 'table.defensive.player.allow_crosses',
  },
  {
    category: 'RECHACES',
    categoryIds: [34],
    items: null,
    translationKey: 'table.defensive.player.clearances',
  },
];

// ToDo: Pending to change a factory to return desired array based on arguments
export function createPossessionPlayerRows() {
  return possessionPlayerTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}

export function createOffensivePlayerRows() {
  return offensivePlayerTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}

export function createDefensivePlayerRows() {
  return defensivePlayerTableRowItems.map(
    ({ category, categoryIds, translationKey, items = null, generalName = '' }) => {
      return new PlayerTableRow(category, categoryIds, translationKey, items, generalName);
    },
  );
}

export const allCategories = (function() {
  let allCategories = [];
  allCategories = allCategories.concat(getDataTablesCategories(possessionPlayerTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(offensivePlayerTableRowItems));
  allCategories = allCategories.concat(getDataTablesCategories(defensivePlayerTableRowItems));
  return allCategories;
})();
